import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const updateName = async (directID, cgId, cg_name) =>
  axios.put(
    `/api/directs/${directID}/consortium_groups/${cgId}`,
    JSON.stringify({ cg_name })
  );
const addSuppliersToConsortiumGroup = async (directID, cgId, companyIds) =>
  axios.post(
    `/api/directs/${directID}/consortium_groups/${cgId}/companies`,
    JSON.stringify({
      direct_id: +directID,
      cg_id: +cgId,
      companies_ids: companyIds,
      company_type: 'supplier',
    })
  );
const removeSupplierFromConsortiumGroup = async (directID, cgId, cgcId) =>
  axios.delete(`/api/directs/${directID}/consortium_groups/${cgId}/companies/${cgcId}
`);

const updateConsortiumGroup = async ({
  directID,
  cgId,
  cg_name = '',
  removedSuppliers = [],
  addedSuppliers = [],
}) => {
  return Promise.all([
    cg_name ? updateName(directID, cgId, cg_name) : null,
    addedSuppliers.length ? addSuppliersToConsortiumGroup(directID, cgId, addedSuppliers) : null,
    ...removedSuppliers.map((cgcId) => removeSupplierFromConsortiumGroup(directID, cgId, cgcId)),
  ]);
};

export const useUpdateConsortiumGroup = () => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: updateConsortiumGroup,
    onSuccess: () => {
      enqueueSnackbar('Consortium group was succesfully updated', {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });

      //   refetch();
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
